export default __webpack_public_path__ + "static/media/twitter-logo.9aba19de.png";